import { createRouter, createMemoryHistory, createWebHistory } from 'vue-router';
import HomePage from '@/components/HomePage.vue';
import PostsPage from "@/components/PostsPage.vue";
import CategoryPage from "@/components/CategoryPage.vue";

// The shop (web v2 SH2): its own page component, loaded only when visited.
const ShopPage = () => import("@/shop/ShopPage.vue");
// Checkout, the page Stripe returns to, and a guest's order page (NX,
// COMMERCE_BUILD.md §6.7). Before /:slug; the page itself falls back to the
// ordinary page while the shop or checkout is off.
const CheckoutPage = () => import("@/shop/CheckoutPage.vue");

const routes = [
    {
        path: '/',
        name: 'mainPage',
        component: HomePage,
        props: true
    },
    {
        path: '/posts',
        name: 'postsPage',
        component: PostsPage,
    },
    {
        path: '/terms-of-service',
        name: 'termsPage',
        component: HomePage,
    },
    {
        path: '/privacy-policy',
        name: 'privacyPage',
        component: HomePage,
    },
    {
        path: '/post/:slug',
        name: 'postPage',
        component: HomePage,
    },
    {
        path: '/contact',
        name: 'contactPage',
        component: HomePage,
        props: { pageName: 'contact' }
    },
    {
        path: '/categories/:slug',
        name: 'categoryPage',
        component: HomePage,
        props: true
    },
    {
        path: '/products/:slug',
        name: 'productPage',
        component: HomePage,
        props: true
    },
    {
        path: '/services/:slug',
        name: 'servicesPage',
        component: HomePage,
        props: true
    },
    {
        path: '/what-we-do/:slug',
        name: 'whatWeDoPage',
        component: HomePage,
        props: true
    },
    {
        path: '/showcase/:slug',
        name: 'datasheetPage',
        component: HomePage,
        props: true
    },
    {
        path: '/products',
        name: 'dynamicPageProducts',
        component: HomePage,
    },
    {
        path: '/services',
        name: 'dynamicPageServices',
        component: HomePage,
    },
    {
        path: '/what-we-do',
        name: 'dynamicPageWhatWeDo',
        component: HomePage,
    },
    {
        path: '/about',
        name: 'dynamicPage2',
        component: HomePage,
    },
    {
        path: '/showcase',
        name: 'dynamicPage3',
        component: HomePage,
    },
    {
        path: '/explore-categories/:slug',
        name: 'exploreCategoryPage',
        component: HomePage,
        props: true
    },
    {path: '/shop', name: 'shopHome', component: ShopPage},
    {path: '/shop/:rest(.*)', name: 'shopPage', component: ShopPage},
    {path: '/checkout', name: 'checkout', component: CheckoutPage},
    {path: '/checkout/return', name: 'checkoutReturn', component: CheckoutPage},
    {path: '/orders/:number(\\d+)', name: 'orderStatus', component: CheckoutPage},
    // The shopper's account (ID, A5: unprefixed), the same way.
    {path: '/orders', name: 'accountOrders', component: CheckoutPage},
    {path: '/account', name: 'account', component: CheckoutPage},
    {path: '/account/sign-in', name: 'accountSignIn', component: CheckoutPage},
    // REV: write a review for one product on an order (?t= token, or the signed-in shopper's account).
    {path: '/orders/:number(\\d+)/review/:productId', name: 'orderReview', component: CheckoutPage},
    // ENG: "stop basket reminders" from the reminder email (signed link, no sign-in).
    {path: '/account/basket-reminders', name: 'accountReminders', component: CheckoutPage},
    // CAT2: anything else under these is a 404, not a blank page.
    {path: '/:area(checkout|account|orders)/:rest(.*)', name: 'checkoutUnknown', component: CheckoutPage},
    {
        // A customer's yes or no to their job being shown here (P1).
        path: '/project-permission/:token',
        name: 'projectPermission',
        component: () => import('@/components/ProjectPermissionPage.vue'),
        props: true
    },
    {
        path: '/:slug',
        name: 'customPage',
        component: HomePage,
        props: true
    }
];

// Export a function to create the router with a custom base for SSR or preview
export function createRouterWithBase(base = '/') {
    return createRouter({
        history: import.meta.env.SSR
            ? createMemoryHistory(base)
            : createWebHistory(base),
        routes
    });
}

let isPreview = false;
if (typeof window !== 'undefined') {
    isPreview = import.meta.env.VITE_IS_PREVIEW_SERVER === 'true'
}
else {
    isPreview = process.env.IS_PREVIEW_SERVER === 'true'
}
const base = isPreview ? '/api/preview/' : '/';

// Conditionally set the base path depending on preview server environment
const router = createRouterWithBase(base);
export default router;
